export { default } from "./CMSImage";
export type { CMSImageProps } from "./CMSImage";
